<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <h2>
          <v-btn
            class="mx-2"
            icon
            text
            small
            :to="{ name: 'pacote-documento-list' }"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <span v-if="loading">Carregando...</span>
          <template v-else>
            <span v-if="pacote.id === ''">Novo pacote de documentos</span>
            <span v-else>Pacote de documentos: {{ pacote.titulo }}</span>
          </template>
        </h2>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-autocomplete
          :items="clientes"
          v-touch="pacote.id_cliente"
          label="Cliente"
          item-value="id"
          item-text="nome"
          v-model="pacote.id_cliente"
          hint="A quem destina-se este pacote de documentos"
          persistent-hint
          required
          :filter="filtrarCliente"
          :error-messages="clienteErrors"
          :disabled="pacote.enviado"
        >
          <template v-slot:item="{ item }">
            <v-list-item-content>
              <v-list-item-subtitle
                >{{ documentoCliente(item) }}
                {{ item.nome }}</v-list-item-subtitle
              >
              <v-list-item-title>{{ item.razao_social }}</v-list-item-title>
            </v-list-item-content>
          </template>
          <template v-slot:selection="{ item }">
            <v-list-item-content>
              <v-list-item-subtitle
                >{{ documentoCliente(item) }}
                {{ item.nome }}</v-list-item-subtitle
              >
              <v-list-item-title>{{ item.razao_social }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
        <v-text-field
          label="Título do pacote de documentos"
          v-model="pacote.titulo"
          v-touch="pacote.titulo"
          maxlength="35"
          counter="35"
          :error-messages="tituloErrors"
          :disabled="pacote.enviado"
          hint="Está informação será anexada no email ao cliente"
          persistent-hint
        />
        <v-textarea
          label="Descrição"
          v-model="pacote.descricao"
          v-touch="pacote.descricao"
          auto-grow
          rows="1"
          hint="Descrição para acompanhamento administrativo e não será anexada no email ao cliente"
          persistent-hint
        />
      </v-card-text>
      <v-card-actions>
        <v-btn depressed color="primary" @click="submit()" :loading="loading"
          >Salvar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import { build } from "../lib/masks";
export default {
  mixins: [validationMixin],
  validations: {
    pacote: {
      titulo: { required },
      id_cliente: { required },
    },
  },
  data() {
    return {
      pacote: {
        id: "",
        id_cliente: null,
        titulo: "",
        descricao: "",
        enviado: false,
      },
      loading: false,
    };
  },
  computed: {
    clienteErrors() {
      const errors = [];
      if (!this.$v.pacote.id_cliente.$dirty) return errors;
      !this.$v.pacote.id_cliente.required && errors.push("Informe o cliente");
      return errors;
    },
    tituloErrors() {
      const errors = [];
      if (!this.$v.pacote.titulo.$dirty) return errors;
      !this.$v.pacote.titulo.required && errors.push("Informe o título");
      return errors;
    },
    ...mapState({
      clientes: (state) => state.cliente.clientes,
    }),
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Pacotes de documentos",
    });
    this.loading = true;
    this.$store.dispatch("cliente/listar", {});

    if (this.$route.params.id) {
      var id = this.$route.params.id;
      this.id = id;

      try {
        this.pacote = await this.$store.dispatch(
          "documento/carregarPacote",
          id
        );
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          title: "Não foi possível carregar o pacote de documentos",
        });
      }
    }
    this.loading = false;
  },
  methods: {
    async submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        try {
          const pacote = await this.$store.dispatch("documento/gravarPacote", {
            ...this.pacote,
          });

          this.$router.replace({
            name: "pacote-documento-docs",
            params: { id: pacote.id },
          });
        } finally {
          this.loading = false;
        }
      }
    },
    documentoCliente(cliente) {
      if (cliente.tipo == "F") {
        return "CPF: " + build.cpf(cliente.cpf_cnpj);
      }
      return "CNPJ: " + build.cnpj(cliente.cpf_cnpj);
    },
    filtrarCliente(item, queryText) {
      const textOne = item.nome.toLowerCase();
      const textTwo = item.cpf_cnpj.toLowerCase();
      const textThree = item.razao_social.toLowerCase();
      const searchText = queryText.toLowerCase();

      return (
        textOne.indexOf(searchText) > -1 ||
        textTwo.indexOf(searchText) > -1 ||
        textThree.indexOf(searchText) > -1
      );
    },
  },
};
</script>
